var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoillustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 406,
    height: 713,
    viewBox: "0 0 406 713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(-1404 -7229)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "$",
    transform: "translate(1404 7493)",
    fill: "#fff",
    fontSize: 337,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    opacity: 0.412
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 364
  }, "$")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "$",
    transform: "translate(1512 7229)",
    fill: "#fff",
    fontSize: 517,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 558
  }, "$")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoillustration);
export default __webpack_public_path__ + "static/media/quoillustration.74f1b4de1641979d95b35b98aeae9e85.svg";
export { ForwardRef as ReactComponent };